import { useState } from 'react'
import { Button, Input, Toggle } from '@/components/ui'
import type { CreateLeaveTypeDto } from '@/features/leave/types/leave.types'

interface LeaveTypeFormProps {
  onSubmit: (body: CreateLeaveTypeDto) => void
  isSubmitting?: boolean
}

/** Adds a leave type. Paid or unpaid is chosen here and decides payroll. */
export function LeaveTypeForm({
  onSubmit,
  isSubmitting = false,
}: LeaveTypeFormProps): React.ReactElement {
  const [label, setLabel] = useState('')
  const [isPaid, setIsPaid] = useState(true)
  const trimmed = label.trim()

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (!trimmed) return
    onSubmit({ label: trimmed, isPaid })
    setLabel('')
    setIsPaid(true)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3" aria-label="Add leave type">
      <Input
        id="leave-type-label"
        label="Name"
        required
        maxLength={60}
        placeholder="e.g. Leave without pay"
        value={label}
        onChange={(event) => setLabel(event.target.value)}
      />
      <Toggle
        id="leave-type-paid"
        checked={isPaid}
        onChange={setIsPaid}
        label="Paid leave"
        description={
          isPaid
            ? 'Approved days are paid as normal.'
            : 'Approved days are deducted from salary in payroll.'
        }
        align="end"
      />
      <Button
        type="submit"
        variant="primary"
        size="sm"
        loading={isSubmitting}
        disabled={!trimmed || isSubmitting}
      >
        Add leave type
      </Button>
    </form>
  )
}

LeaveTypeForm.displayName = 'LeaveTypeForm'
